import { Component, OnInit, Output, EventEmitter, ViewChild, } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { GeneralService } from 'src/app/service/general.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { authpermission, CertificationListBO, ClientCertificationBO, editcertificate, functionpermission } from '../client-parent.model';
import { DataStateChangeEventArgs, FilterSettingsModel, QueryCellInfoEventArgs } from '@syncfusion/ej2-grids';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ColumnChangeBO, columnWidth } from '../../list/list.model';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonApiService } from 'src/app/commonapiservice';
import { Guid } from '@syncfusion/ej2/pdf-export';

@Component({
  selector: 'app-client-certificate-list',
  templateUrl: './client-certificate-list.component.html',
  styleUrls: ['./client-certificate-list.component.scss']
})
export class ClientCertificateListComponent implements OnInit {
    private onDestroy$: Subject<void> = new Subject<void>();
    @ViewChild('grid') public grid: GridComponent;
    columnchange: ColumnChangeBO = new ColumnChangeBO();
    id: Guid;
    arraycol: any = [];
    ColumnArray: columnWidth[]
    LCertificationList: ClientCertificationBO[];
    fp: authpermission = new authpermission()
    deletecertificate: number = 0;
    initialPage: object;
    public formatOptions: object;
    public data: Observable<DataStateChangeEventArgs>;
    ICD10List: [{ Key: string, Value: string }];
    ListBO: CertificationListBO = new CertificationListBO();
    filterOptions: FilterSettingsModel;
    @Output() DatafromCertificate = new EventEmitter<editcertificate>();
    EditOptions: editcertificate = new editcertificate();
    CertificationTotalColumns:number=10;
    constructor(public CommonAPI: CommonApiService, public toastrService: ToastrService, public http: HttpClient, public datepipe: DatePipe, public general: GeneralService,  public global: GlobalComponent,  ) {
      this.global.agencyList();
      this.data = CommonAPI;
    }
    ngOnInit(): void {
      this.clearGridLocalStorage();
      this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
      this.getClientCertificationList();
      this.getpermission();
      // let pag = JSON.parse(this.global.globalColumn.column)[0].Certification.Pagesize;
      let pag = 10;
      this.initialPage = { pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: pag };
      this.ListBO.pageitem = pag;
    }
    //==================================get certification list========================//
    getClientCertificationList() {
      this.ListBO.clientId = this.global.clientId;
      let val = 0;
      let url = "api/Certification/GetCertificationList"
      let responseData =
      {
        result: "result",
        count: "count",
      }
      this.CommonAPI.outputValues(url, this.ListBO, responseData, "");
      this.data.pipe(takeUntil(this.onDestroy$)).subscribe((datas: any) => {
        val++;
        this.LCertificationList = datas.result;
        if (datas != null && datas != undefined && val == 1) {
          // this.getColumnwidth();
        }
      })
    }
    //============================== Tooltip =========================================================//
    headerCellInfo(args) {
      const toolcontent = args.cell.column.headerText;
      const tooltip: Tooltip = new Tooltip({
        content: toolcontent
      });
      tooltip.appendTo(args.node);
    }
    tooltip(args: QueryCellInfoEventArgs) {
      if (args.column.field != null) {
        if (args.data[args.column.field] != null) {
          const tooltip: Tooltip = new Tooltip({
            content: args.data[args.column.field].toString(),
            position: 'RightCenter',
          }, args.cell as HTMLTableCellElement);
        }
      }
    }
    //======================================get permission==========================================================//
    getpermission() {
      let params = new URLSearchParams();
      params.append("pagecode", "Client");
     // params.append("agencyId", this.global.agencyId);
      let url = "api/FunctionPermission/getfunctionpermissionemployee?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new authpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new authpermission();
        })
    }
    //============================Add client======================//
    AddCertificate(modalType: string, data) {
      if (modalType == 'new') {
        this.EditOptions.isEdit = true;
        this.EditOptions.type = 'new';
        this.EditOptions.clientId = this.global.clientId
        this.EditOptions.certificateId = 0;
        this.DatafromCertificate.emit(this.EditOptions);
      }
      if (modalType == 'edit') {
        this.EditOptions.certificateId = data.id;
        this.EditOptions.type = 'edit';
        this.EditOptions.isEdit = true;
        this.EditOptions.clientId = this.global.clientId
        this.EditOptions.clientcertifcateData = JSON.parse(JSON.stringify(data));
        this.DatafromCertificate.emit(this.EditOptions);
      }
      if (modalType == 'delete') {
        this.EditOptions.certificateId = data.id;
        this.EditOptions.type = 'delete';
        this.EditOptions.clientId = this.global.clientId
        this.EditOptions.isEdit = true;
        this.EditOptions.clientcertifcateData = data;
        this.DatafromCertificate.emit(this.EditOptions);
      }
    }
    //===================================Get COmmon Icd10=========================//
    getICD10List() {
      let url = "api/Client/commonICDList"
      this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
        this.ICD10List = data;
        this.ICD10List.forEach(element => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        })
      })
    }
  
  
  
    getColumnwidth() {
      this.arraycol = JSON.parse(this.global.globalColumn.column);
      this.ColumnArray = this.arraycol[0].Certification.Columns;
      this.grid.hideColumns(this.arraycol[0].Certification.HideColumns);
      if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
        this.id = this.global.globalColumn.id;
      }
      this.grid.pageSettings.pageSize = this.arraycol[0].Certification.Pagesize;
      this.ColumnArray.forEach(element => {
        if (element.column == 'Start Of Care') {
          const column = this.grid.getColumnByField('socDate');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Start Date') {
          const column1 = this.grid.getColumnByField('startDate');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'End Date') {
          const column = this.grid.getColumnByField('endDate');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Company') {
          const column = this.grid.getColumnByField('companyName');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'ICD10(Primary)') {
          const column = this.grid.getColumnByField('icD10PrimaryIdCode');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'ICD10 Description') {
          const column = this.grid.getColumnByField('icD10Description');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'NPI') {
          const column = this.grid.getColumnByField('npi');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Physician') {
          const column = this.grid.getColumnByField('physician');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Clinic') {
          const column = this.grid.getColumnByField('clinic');
          column.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Actions') {
          const column2 = this.grid.getColumnByUid('action');
          column2.width = element.width;
          this.grid.refreshHeader();
        }
      });
    }
    SaveColumnwidth() {
      this.arraycol[0].Certification.Columns = this.ColumnArray;
      this.arraycol[0].Certification.Pagesize = this.grid.pageSettings.pageSize;
      this.columnchange.userid = this.global.userID;
      this.columnchange.column = JSON.stringify(this.arraycol);
      this.columnchange.id = this.id;
      this.global.globalColumn = this.columnchange;
      this.arraycol = JSON.parse(this.global.globalColumn.column);
      let url = "api/ColumnChange/Savewidth?";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        // this.getColumnwidth();
      });
    }
  
  
    onResize(args) {
      if (this.ColumnArray != undefined && this.ColumnArray != null) {
        const column = this.grid.getColumnByField(args.column.field)
        column.width = args.column.width;
        this.ColumnArray.forEach(element => {
          if (element.column == column.headerText) {
            element.width = parseInt(column.width.toString());
          }
        });
        // this.SaveColumnwidth();
      }
    }
  
    //========================= evnt change =====================================================================//
    public dataStateChange(state): void {
      let val = (state.action.requestType).toString();
      if (val != "filterchoicerequest") {
        if ((state.sorted || []).length) {
          this.ListBO.orderColumn = "CompanyName";
          this.ListBO.orderType = 'asc';
  
        }
      }
      if (this.ListBO.type == "date") {
        this.ListBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.ListBO.field = state.action.currentFilterObject.field;
      }
  
      if (val == "filtering" && state.action.action != "clearFilter") {
        this.ListBO.field = state.action.currentFilterObject.field;
        this.ListBO.matchCase = state.action.currentFilterObject.matchCase;
        this.ListBO.operator = state.action.currentFilterObject.operator;
        this.ListBO.value = state.action.currentFilterObject.value;
      }
      else {
        if (val == "filtering" && state.action.action == "clearFilter") {
          this.ListBO.field = "CompanyName";
          this.ListBO.matchCase = false;
          this.ListBO.operator = "contains";
          this.ListBO.value = "";
          this.ListBO.type = "string"
          this.ListBO.clientId = this.global.clientId;
        }
      }
      if (val == "paging" && state.action.name == "actionBegin") {
  
        if (this.arraycol.length != 0) {
          if (this.arraycol[0].Certification.Pagesize != state.take) {
            this.arraycol[0].Certification.Pagesize = state.take
            // this.SaveColumnwidth();
  
          }
  
        }
  
      }
      this.getClientCertificationList();
    }
  
    /////////////////////////////Action Begin ////////////////////////////////////////////////////////
  
    public onActionComplete(args) {
      this.ListBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
      this.ListBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
  
      if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
        this.ListBO.type = args.columnType
      }
  
    }
    showGridColumns() {
  
      this.grid.columnChooserModule.openColumnChooser(200, 50);
    }
       clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridCERTGrid', expectedColumns: this.CertificationTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
    public ngOnDestroy(): void {
      this.onDestroy$.next();
    }
  }